import { z } from 'zod';

import { optionalTextSchema, requiredTextSchema } from 'schemas/api/common';

// The profile page edits the name and email, shows the commercial structure as text, and sends the rest back as it came.
export const userDetailsSchema = z.looseObject({
    name: requiredTextSchema,
    email: requiredTextSchema,
    user_type: z.string().nullish(),
    channel: z.string().nullish(),
    partner: z.string().nullish(),
    supervisor: z.string().nullish(),
});

// The details come as a list holding the user's single entry.
export const userDetailsListSchema = z.array(userDetailsSchema).transform(([userDetails]) => userDetails ?? null);

// Saving the profile can answer with a new session token, which replaces the old one.
export const updatedUserDetailsSchema = z
    .looseObject({ token: optionalTextSchema })
    .nullish()
    .transform((updated) => updated?.token);
